<!--
 * @Author: FengXiao
 * @Date: 2020-07-26 14:18:29
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-19 16:20:32
-->
<template>
	<div class="wanxiang-detail-page page-container" @click="selectBtn()" @contextmenu.prevent="selectBtn()">
		<video-player :datas="videoData" :speaker="speaker" :allowEvent.sync="playerAllowEvent" @playNext="focusChapter"
			:index="chapterIndex" :auto-play="true" :muted="false" ref="videoPlayer" controlslist="nodownload">
			<div class="right-area" slot="right-area">
				<div class="speaker-info-bl">
					<div class="wanxiang-speaker-info-wrap">
						<div class="speaker-info">
							<div class="speaker_avatar">
								<img class="speaker_avatar-img" :src="speaker.avatar" alt />
							</div>
							<div class="speaker_name">{{ speaker.name }}</div>
							<div class="speaker_intro">{{ speaker.intro }}</div>
							<div class="speaker_rank">
								<span v-if="speaker.rank !== 0">一席第{{ speaker.rank }}位演讲者</span>
								<span v-else>一席讲者</span>
							</div>
						</div>
						<div class="actions-bl">
							<!-- 隐私改版：移除收藏按钮，全站匿名访问 -->
							<div class="gift_btn" @click.stop="giving">
								<img src="../assets/icon/gift.svg" alt="" class="gift_btn-icon" />
								<span>赠送</span>
							</div>
						</div>
					</div>
				</div>
				
				<template v-if="!needPay && chapters.length && !isColumn">
					<div class="episodes-title">分集目录</div>
					<div class="episodes" :class="{ hasActions: pageData.show_pay !== 0 }">
						<div v-for="(item, index) in chapters" :key="item.id" class="episode-title"
							:class="{ active: chapterIndex === index }" @click.stop="onSelectChapter(index)"
							:ref="`episode-title-${index}`">
							<span> {{ index + 1 }}、{{ item.title }} </span>
							<span class="episode-time" :class="{ hasOmit: item.title.length > 32 }">
								<span class="omit" v-if="item.title.length > 32">...</span>
								{{ item.video_duration }}
							</span>
						</div>
					</div>
				</template>
				<!-- 隐私改版：官网不可登录购买，改为引导打开App观看 -->
				<div class="video-actions-bl" v-if="pageData.show_pay !== 0 && pageData.is_free_time !== 1">
					<button class="buy_class-btn open-app-btn" @click="checkLogin('app')">打开一席App观看</button>
				</div>
				<div class="video-actions-bl" v-if="pageData.is_free_time == 1">
					<div class="free_tips">
						<div class="free_title">限时免费</div>
						<div class="free_intro"><span>{{pageData.free_time_days}}</span>后恢复原价{{pageData.course_original_price}}元</div>
					</div>
				</div>
			</div>
		</video-player>
		<div class="content">
			<episode-list :title="episodeTitle" :datas="episodeList" :is_free_time="pageData.is_free_time" :init-slide="initSlide" v-if="episodeList.length"
				@select="onSelectEpisode"></episode-list>
			<div class="container-wrap" :class="{ 'no-recommend': !recommendList.length }">
				<div class="left-bl" v-if="!isColumn">
					<h1 class="detail_title">{{ pageData.title }}</h1>
					<div class="detail_meta" v-if="detailMeta">{{ detailMeta }}</div>
					<transition name="el-fade-in-linear">
						<!-- 隐私改版：无文稿时显示占位提示 -->
						<div v-if="draft" key="draft" class="child-bl" v-html="draft"></div>
						<div v-else key="empty" class="draft-empty">本篇暂无文稿</div>
					</transition>
				</div>
				<div class="left-bl" v-else>
					<div v-html="courseInfo"></div>
				</div>
				<div class="right-bl">
					<recommend-videos :datas="recommendList" @click="onClickRecommend"></recommend-videos>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import VideoPlayer from '@/components/AppVideoPlayer';
	import EpisodeList from '@/components/AppEpisodeList';
	import RecommendVideos from '@/components/AppRecommendVideos';
	import requestApi from '@/service';

	import configFields from '@/utils/configFields';
	const {
		DRAFT_TYPE
	} = configFields;
	export default {
		name: 'WanXiangDetail',
		components: {
			VideoPlayer,
			EpisodeList,
			RecommendVideos,
		},
		data() {
			return {
				playerAllowEvent: false, // 允许当前视频支持键盘事件
				pageData: {},
				videoData: {},
				speaker: {},
				episode: {},
				episodeList: [],
				recommendList: [], // 推荐列表
				topic: {}, // 评论顶部信息
				isColumn: 1, // 是否为万象栏目
				courseInfo: '', // 栏目状态时 富文本介绍
				draft: '', // 打开某个单独集时 富文本
				episodeId: null,
				chapters: [], // 本集（小课）分集列表
				chapterIndex: 0, // 当前选中小节index
			};
		},
		mounted() {
			this.init();
			this.getDraft(true); // 隐私改版：文稿常驻展示，进入页面即加载
		},
		computed: {
			detailMeta() {
				// 讲者 · 日期
				return [this.speaker && this.speaker.name, this.topic.date].filter(Boolean).join(' · ');
			},
			needPay() {
				return this.pageData.pay_type !== 0 && this.pageData.already_bought === 0;
			},
			initSlide() {
				let index = 0;
				for (let i = 0; i < this.episodeList.length; i++) {
					if (this.episodeList[i].id === this.episodeId) {
						index = i;
						break;
					}
				}
				return index;
			},
		},
		watch: {
			$route(to) {
				if (to.path === '/wanxiang/detail') {
					this.init();
					this.draft = '';
					this.getDraft(true); // 隐私改版：切换视频时文稿跟随刷新
				}
			},
		},
		methods: {
			selectBtn() {
				// console.log("禁用右健")
			},
			init() {
				Object.assign(this.$data, this.$options.data());
				this.wanxiangId = +this.$route.query.id || '';
				this.episodeId = +this.$route.query.episodeId;
				this.isColumn = +this.$route.query.isColumn === 1;
				this.refreshPage();
			},
			/**
			 * @description: 赠送
			 */
			giving() {
				if (this._riverClosure('gavingBtn', 800)) {
					this.openPayPopup(true);
				}
			},
			refreshPage() {
				this.getData();
				this.getRecommend();
				if (this.isColumn) {
					this.getCourseInfo();
				}
				this.initScrollTop();
			},
			/**
			 * @description: 像首页、收藏、推荐进来的地方 由于没有wanxiangid 所以只能在等详情返回之后获取base里的wanxiangid 再去请求其他数据 啊 FML
			 */
			getData() {
				requestApi(`/v3/api/site/wanxiang/${this.episodeId}/detail/`).then(({
					items,
					base
				}) => {
					if (!this.wanxiangId) {
						this.wanxiangId = base.id;
						this.getRecommend();
						if (this.isColumn) {
							this.getCourseInfo();
						}
					}
					this.pageData = base;
					this.speaker = base.speaker;
					document.title = `${base.title} - 一席`;
					this.episodeList = items;
					this.episodeTitle = base.title;
					const {
						chapters,
						cover,
						video_url,
						title,
						first_category,
						date,
						titlelanguage
					} = this.getCurEpisode(items);
					// 使用 map 方法替换 video_url 中的 http:// 为 https://
					const updatedVideoUrls = video_url.map(item => {
					if (item.video_url) {
						item.video_url = item.video_url.replace('http:', 'https:');
					}
					return item;
					});
					this.videoData = {
					  cover,
					  videoUrls: updatedVideoUrls,
					};
					const free = this.getCurEpisode(items).is_free
					if (this.isColumn || this.needPay && !free && this.pageData.is_free_time !== 1) {
						this.videoData = {
							cover: base.base_cover,
							videoUrls: [{
								type: 1,
								type_name: '标清',
								video_url: base.base_video.replace('http:', 'https:'),
							}, ],
						};
					} else {
						this.topic = {
							title,
							category: first_category,
							date,
							intro: titlelanguage,
						};
					}
					console.log(this.episodeId)
					console.log(items)
				});
			},
			/**
			 * @description: 获取当前播放集
			 */
			getCurEpisode(data = this.episodeList) {
				return data.filter(item => item.is_current)[0];
			},
			/**
			 * @description: 获取演讲稿
			 */
			getDraft(silent = false) {
				return new Promise(resolve => {
					requestApi('/v3/api/site/draft/', {
						id: this.episodeId,
						type: DRAFT_TYPE.wanxiang,
					}).then(({
						draft
					}) => {
						if (draft) {
							this.draft = draft;
							resolve(true);
						} else {
							if (!silent) this.$message.error('未找到文稿');
							resolve(false);
						}
					});
				});
			},
			/**
			 * @description: 获取万象课程详情 展示的大图片
			 */
			getCourseInfo() {
				if (this.wanxiangId) {
					return new Promise(resolve => {
						requestApi(`/v3/api/site/wanxiang/${this.wanxiangId}/course_intro/`, {
							id: this.recordId,
							type: DRAFT_TYPE.record,
						}).then(({
							course_info
						}) => {
							if (course_info) {
								this.courseInfo = course_info;
								resolve(true);
							} else {
								this.$message.error('未找到文稿');
								resolve(false);
							}
						});
					});
				}
			},
			inputFocus(val) {
				if (val) {
					this.playerAllowEvent = false;
				}
			},
			getRecommend() {
				if (this.wanxiangId) {
					const url = `/v3/api/site/wanxiang/${this.wanxiangId}/recommend/`;
					requestApi(url).then(({
						recommended
					}) => {
						this.recommendList = recommended && recommended.length ? recommended : [];
					});
				}
			},
			/**
			 * @description: 选分集
			 */
			onSelectEpisode(data) {
				if (this.pageData.is_free_time == 1 || !this.needPay || data.is_free) {
					console.log(this.wanxiangId,data.id)
					this.gotoWanXiangDetail(this.wanxiangId, data.id, 0);
				} else {
					// 隐私改版：无购买能力，引导下载一席App观看
					this.checkLogin('app');
				}
			},
			// 选分集（章、小节）
			onSelectChapter(index) {
				this.chapterIndex = index;
			},
			/**
			 * @description: 打开支付弹窗
			 * isGaving: 是否是赠送
			 * pageData.show_pay：
			    0 正常展示
			    1/2/3 均引导打开一席App
			    2 显示购买课程
			    3 显示购买实物
			 */
			openPayPopup() {
				// 隐私改版：赠送/购买涉及账号与支付，统一引导打开一席App
				this.checkLogin('app');
			},
			onClickRecommend(episodeId) {
				this.gotoWanXiangDetail('', episodeId);
			},
			gotoWanXiangDetail(id, episodeId, isColumn = 1) {
				this.$router.push({
					path: '/wanxiang/detail',
					query: {
						id,
						episodeId,
						isColumn,
					},
				});
			},
			btnAction() {
				if ([1, 2, 3].includes(+this.pageData.show_pay)) {
					this.openPayPopup();
				}
			},
			// 聚焦当前播放的这一集
			focusChapter(data, index) {
				this.chapterIndex = index;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.wanxiang-detail-page {
		.detail_title {
			font-size: 28px;
			font-weight: 600;
			color: #333;
			line-height: 1.5;
			margin: 4px 0 8px;
		}

		.detail_meta {
			font-size: 14px;
			color: #999;
			line-height: 1.5;
			margin: 0 0 20px;
		}

		.video-player-content .right-area {
			position: absolute;
			right: 0;
			top: 40px;
			height: calc(100% - 80px);
			max-height: 100%;
			box-sizing: border-box;
			padding: 40px 0 20px;

			.speaker-info-bl {
				display: block;
				flex: 1;
				padding: 0 24px;
				position: relative;
			}
			.wanxiang-speaker-info-wrap {
				box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);

				.speaker-info {
					position: relative;
					display: flex;
					align-items: center;
					flex-direction: column;
					box-sizing: border-box;
					padding-bottom: 20px;
					width: 210px;
					max-width: 100%;
					margin: auto;
					border: none;

					.speaker_avatar {
						width: 56px;
						height: 56px;
						min-height: 56px;
						border-radius: 50%;
						overflow: hidden;
						margin: -28px 0 10px;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.25));
					}

					.speaker_name {
						margin-bottom: 8px;
						font-size: 15px;
						line-height: 15px;
						color: $C6;
					}

					.speaker_intro {
						font-size: 13px;
						color: $C4;
						line-height: 13px;
						margin-bottom: 8px;
						padding: 0 5px;
					}

					.speaker_rank {
						font-size: 13px;
						line-height: 13px;
						color: #bdbdbd;
					}
				}

				.actions-bl {
					display: flex;
					border-top: 1px solid #eee;

					.gift_btn {
						flex: 2;
						height: 36px;
						color: $C3;
						font-size: 14px;
						display: inline-flex;
						justify-content: center;
						align-items: center;
						cursor: pointer;

						&-icon {
							width: 15px;
							height: 15px;
							margin-right: 10px;
							vertical-align: middle;
						}
					}
				}
			}

			.episodes-title {
				font-size: 12px;
				line-break: 14px;
				margin: 38px 0 10px;
				color: $C3;
				padding: 0 24px;
			}

			.episodes {
				font-size: 12px;
				line-height: 14px;
				color: $C3;
				overflow-y: auto;
				flex: 1;
				padding: 0 24px;
				margin-bottom: 15px;

				&.hasActions {
					margin-bottom: 35px;
				}

				.episode-title {
					background: $C10;
					color: $C3;
					width: 100%;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					text-overflow: ellipsis;
					overflow: hidden;
					word-wrap: break-word;
					word-break: break-all;
					padding: 8px 15px;
					text-align: justify;
					margin-bottom: 5px;
					box-sizing: border-box;
					position: relative;
					cursor: pointer;

					&>span {
						max-height: 30px;
						display: block;
						position: relative;
						overflow: hidden;
					}

					&:last-child {
						margin-bottom: 0;
					}

					.episode-time {
						position: absolute;
						right: 15px;
						bottom: 8px;
						display: flex;
						align-items: center;
						justify-content: space-between;
						background: $C10;
						&.hasOmit {
							padding-left: 5px;
						}
						.omit {
							display: inline-block;
							margin-right: 20px;
						}
					}
					&.active {
						color: $C7;
					}
				}
			}
		}

		.video-actions-bl {
			position: relative;
			width: 100%;
			text-align: center;
			justify-content: center;
			display: flex;
			align-items: flex-end;
			padding:0 6.5%;
			box-sizing: border-box;
			.buy_class-btn {
				border: none;
				outline: none;
				width: 34%;
				height: 65px;
				background: rgba(218, 63, 52, 0.4);
				color: $C1;
				text-align: center;
				cursor: pointer;
				font-family: HYXinRenWenSongW;
				// opacity: 0.9;
				// &:hover {
				// 	opacity: 1;
				// }
			}
			.buy_class-btn2 {
				width: 53%;
				background: #DA3F34;
			}
			.open-app-btn {
				width: 100%;
				background: #DA3F34;
			}
			.free_tips {
				display: flex;
				color: #CA644A;
				width: 100%;
				align-items: center;
				justify-content: space-around;
				.free_title {
					font-weight: 500;
					font-size: 16px;
					line-height: 22px;
				}
				.free_intro {
					background: #FFEEE4;
					border-radius: 2px;
					padding: 4px 8px;
				}
			}
		}

		.content {
			.container-wrap {
				// 无推荐内容时左栏撑满整行
				&.no-recommend {
					.left-bl {
						width: 100%;
						max-width: 100%;
					}
					.right-bl {
						display: none;
					}
				}

				display: flex;
				align-items: flex-start;
				margin: 10px auto 100px;
			}

			.left-bl {
				width: 72%;
				max-width: 827px;
				margin-right: 10px;
				box-sizing: border-box;
				background: $C1;
				padding: 20px;
			}

			.right-bl {
				width: 28%;
				background-color: $C10;
			}
		}
	}

.draft-empty {
  padding: 80px 0;
  text-align: center;
  font-size: 14px;
  color: #999999;
}
</style>
